export default __webpack_public_path__ + "static/media/fad-modularplug.ce02163a.svg";